import { MODEL_TYPE, Row } from './models';
import SmsIcon from '@mui/icons-material/Sms';
import CallIcon from '@mui/icons-material/Call';
import AssignmentIcon from '@mui/icons-material/Assignment';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SupportAgent from 'components/svg-icons/support-agent';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import { DataGridLightRowProps } from 'components/data-grid-light';
import { hexToRgb, rgba2hex } from 'components/helpers';

export const CONFIG_MODEL_TYPE = {
  [MODEL_TYPE.SMS]: { Icon: SmsIcon, color: '#27AE60' },
  [MODEL_TYPE.CALL]: { Icon: CallIcon, color: '#27AE60' },
  [MODEL_TYPE.PRESCRIPTION]: { Icon: AssignmentIcon, color: '#2798D4' },
  [MODEL_TYPE.DOCUMENT]: { Icon: InsertDriveFileIcon, color: '#2798D4' },
  [MODEL_TYPE.SIGNED_DOCUMENT]: { Icon: DescriptionIcon, color: '#2798D4' },
  [MODEL_TYPE.USER_DOCUMENT]: { Icon: AssignmentIndIcon, color: '#2798D4' },
  [MODEL_TYPE.SUBSCRIPTION]: { Icon: CardMembershipIcon, color: '#F8D000' },
  [MODEL_TYPE.SESSION]: { Icon: NewReleasesIcon, color: '#F8D000' },
  [MODEL_TYPE.MEDICAL_INFORMATION]: { Icon: LocalHospitalIcon, color: '#F8D000' },
  [MODEL_TYPE.CLINICAL_MEETING]: { Icon: EventAvailableIcon, color: '#F49511' },
  [MODEL_TYPE.SUPPORT_MEETING]: { Icon: SupportAgent, color: '#F49511' },
  [MODEL_TYPE.TASK]: { Icon: FlashOnIcon, color: '#F6AA41' },
  [MODEL_TYPE.NOTE]: { Icon: NoteAddIcon, color: '#eb5757' },
  [MODEL_TYPE.ACTIVITIES]: { Icon: LocalActivityIcon, color: '#2798D4' },
};

const OPACITY = 0.06;

export const calcBgColor = (type: MODEL_TYPE) => {
  const colorHex = CONFIG_MODEL_TYPE[type].color;
  const { r, g, b } = hexToRgb(colorHex);
  return rgba2hex(r, g, b, OPACITY);
};

export const calcRowProps: DataGridLightRowProps<Row> = (row) => {
  return {
    style: { backgroundColor: calcBgColor(row.type) },
  };
};
